
<template>
  <div class="content alarmCensus" ref="tableBox" id="tableBox">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName" :style="{
		position: 'static'
	}">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 巡检统计
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="search">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <!-- <button class="GreenSmBtn" @click="download">导出</button> -->
        </div>
        <div class="searchForm1">
          <el-form ref="formData" :model="formData" :class="className">
            <el-form-item label="部门">
              <el-input placeholder="请选择部门" v-model="formData.curAreaName" @focus="$refs.departDialog.look()"></el-input>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker v-model="formData.startTime" :value-format='valueFormat' :type="dataType" placeholder="选择时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker v-model="formData.endTime" :value-format='valueFormat' :type="dataType" placeholder="选择时间">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div class="detailtab nonedetailtab" v-if="showCont">
          <div>请搜索</div>
        </div>
        <div class="detailtab" v-if="!showCont">
          <div class="leftBar">
            <inspection-dialog :chartData='chartData' :tableCalcul='tableCalcul'></inspection-dialog>
          </div>
          <div class="rightTable">
            <right-tables :listData='listData' :items='items' :tableCalcul='tableCalcul'></right-tables>
          </div>
        </div>
        <depart-dialog ref='departDialog'></depart-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  components: {
    normalNav: () => import("public/normalNav"),
    rightTables: () => import("./rightTables"),
    inspectionDialog: () => import("./inspectionDialog"),
    departDialog: () => import("./departDialog"),
    mountPoint: () => import("public/mountPoint"),
  },
  data() {
    return {
      tabName: "jsgl",
      formData: {
        areaId: "",
        endTime: "",
        startTime: "",
        chart: "条形图",
        curAreaName: "",
      },
      systemArr: [],
      areaArr: [],
      chartArr: [{ name: "面积图" }, { name: "条形图" }],
      format: "yyyy 年 MM 月 dd 日",
      valueFormat: "yyyy-MM-dd",
      dataType: "date",
      className: "collapse",
      showBar: false,
      showLine: false,
      chartData: { xData: [], seriesData: { one: [], two: [] } },
      items: [
        {
          prop: "name",
          label: "区域",
        },
        {
          prop: "sumCounts",
          label: "巡检数量",
        },
        {
          prop: "checkCpunts",
          label: "收工回查",
        },
        {
          prop: "dailyCounts",
          label: "日常巡检",
        },
        {
          prop: "belowCounts",
          label: "不合格数",
        },
      ],
      listData: [],
      showCont: true,
      tableCalcul: [],
      //区域树是否显示
      areaTreeVisible: false,
      inputReadOnly: false,
      //区域树模式选择
      areaTreeMode: true,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
      id: null,
    };
  },
  created() {},
  mounted() {},
  methods: {
    bindchart() {
      if (this.formData.chart == "面积图") {
        this.showLine = true;
        this.showBar = false;
      } else {
        this.showLine = false;
        this.showBar = true;
      }
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.formData.areaId = a.id;
        this.formData.curAreaName = a.name;
      }
    },
    search() {
      if (this.id != null) {
        let data = this.formData;
        this.$axiosget("operation/task/findCountsByDept", {
          params: {
            id: this.id,
            startTime: data.startTime.length
              ? data.startTime.concat(" 00:00:00")
              : "",
            endTime: data.endTime.length
              ? data.endTime.concat(" 00:00:00")
              : "",
          },
        }).then(res => {
          let data = res.data.data;
          this.listData = data;
          let check = [],
            daily = [],
            nameArr = [],
            checkCount = null,
            belowCount = null;

          data.forEach(element => {
            checkCount += element.sumCounts;
            belowCount += element.belowCounts;
            check.push(element.checkCpunts);
            daily.push(element.dailyCounts);
            nameArr.push(element.name);
          });
          this.chartData = {
            xData: nameArr,
            seriesData: { one: check, two: daily },
          };
          this.tableCalcul = [checkCount, belowCount];
          // if (this.formData.chart == "面积图") {
          //   this.showLine = true;
          //   this.showBar = false;
          // } else {
          //   this.showLine = false;
          //   this.showBar = true;
          // }
          this.showCont = false;
          // this.getData(res.data.data);
        });
      } else {
        this.$message.error("请选择部门");
      }
    },
    reset() {
      this.formData = {
        areaId: "",
        endTime: "",
        startTime: "",
        chart: "面积图",
        curAreaName: "",
      };
      this.showCont = true;
    },
  },
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  height: 100%;
  padding-top: 0 !important;
  img {
    width: 100%;
  }
}
.nonedetailtab {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(181, 181, 181);
}
.breadcrumb {
  margin-top: 0;
}
.detailtab {
  background-color: #181c2e;
  display: flex;
  width: 100%;
  height: calc(100% - 73px);
  padding-top: 20px;
  .rightTable {
    width: 520px;
    height: 100%;
    background-color: #232944;
  }
  .leftBar {
    flex: 1;
    position: relative;
    margin-right: 20px;
  }
}
</style>
<style lang='less'>
.boxs .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
}
.boxs .alarmCensus .el-tabs {
  height: 100%;
}
.boxs .alarmCensus .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
}
.boxs .alarmCensus .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}
.alarmCensus .el-tabs,
.alarmCensus .el-tabs .content,
.alarmCensus .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}
.alarmCensus .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
}
.box .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
}
.alarmCensus .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
  .el-date-editor {
    width: calc(100%);
  }
  .el-range-input {
    background: #2e3657;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/reportForms/XJstatistics.vue